import { Injectable, NgZone } from '@angular/core';
import { IGoogleMap, IMapOptions } from 'src/app/core/models/google-map-models';
import {  MarkerType, TrafficAlertType } from '../../enums/google-map-enum';
import { MapContextMenuEvents } from 'src/app/core/events/events';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { RoutePlannerDataModel } from 'src/app/modules/route-planner/models/route-model';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsAPIWrapperService {
  private _map: Promise<IGoogleMap>;
  private _mapPromise: Promise<IGoogleMap>;
  constructor(private _zone: NgZone, private appUtility: AppUtilityService) {
    this._map = new Promise<IGoogleMap>(() => { });
  }

  createMap(el: HTMLElement, mapOptions: IMapOptions): Promise<IGoogleMap> {
    return this._zone.runOutsideAngular(() => {
      this._map = new google.maps.Map(el, mapOptions);
      return Promise.resolve(this._map);
    });
  }

  /**
   * Returns the native Google Maps Map instance. Be careful when using this instance directly.
   */
  getNativeMap(): Promise<IGoogleMap> {
    return Promise.resolve(this._map);
  }

  /**
   * @param {*} markerDataObj
   * @returns
   * @memberof GoogleMapsAPIWrapperService
   */
  getTrafficMarkerInfoWindowHtmlContent(markerDataObj: any) {
    // Info window html content
    const markerColor = this.getRoadType(markerDataObj.roadName);
    const twitterLink: string = this.appUtility.fixedEncodeURIComponent('http://www.theaa.com/traffic-news/index.jsp?lat=' + markerDataObj.lat + '&lng=' + markerDataObj.lon + '&searchPlace=' + this.appUtility.fixedEncodeURIComponent(markerDataObj.roadName));
    const twitterRoadName = this.appUtility.fixedEncodeURIComponent(`#${markerDataObj.roadName}`);
    const hashAATag = this.appUtility.fixedEncodeURIComponent(`#AATraffic`);
    let $twitterLimit = (markerDataObj.eventText) ? markerDataObj.eventText  : markerDataObj.description;
    $twitterLimit = $twitterLimit.split(' ').splice(0, 10).join(' ');
    const descString = markerDataObj.description;
    const length = 265;
    const trimmedString = descString.length > length ? descString.substring(0, length - 3) + '...' : descString.substring(0, length);
    if ( markerDataObj.aaIncidentType === TrafficAlertType.CONGESTION) {
       $twitterLimit = markerDataObj.eventText = '';
    }

    return `<div class='iw-traffic' id='aa-iwindow'>
      <div class="iw-wrapper">
        <div class="iw-content">
          <span class='iw-traffic-location trafficRoadName ${markerColor}'>${markerDataObj.roadName} </span>
        </div>
        <div class="mapSprite_twitter">
          <a href="https://twitter.com/intent/tweet?text=${twitterRoadName} :${$twitterLimit}. ${twitterLink} ${hashAATag}" target="_blank">
            <div class="twitter_logo"> </div>
          </a>
        </div>
      </div>
      <div class='iw-traffic-title'><strong>${ markerDataObj.eventText }</strong></div>
      <div class='iw-traffic-desc'>${trimmedString}</div>
      <div class='iw-traffic-date'>${this.getInfoWindowDateTime( markerDataObj.startTime )} (first reported)</div>
    </div>`;
  }

  /**
   * @param {*} markerDataObj
   * @returns
   * @memberof GoogleMapsAPIWrapperService
   */
  getCarParkMarkerInfoWindowHtmlContent(markerDataObj: any) {
    const address = markerDataObj.parkingAddress;

    const addressToPopup: Array<string> = [address.city];
    const addressToDirection: Array<string> = [markerDataObj.parkingAddress.addressLineOne];
    const $title: string = (markerDataObj.title) ? `<p>${markerDataObj.title}</p>` : '';

    if (address && address.postcode) {
      addressToPopup.push(address.postcode);
      addressToDirection.push(address.postcode);
    }

    const directionAddress: string = this.appUtility.fixedEncodeURIComponent( addressToDirection.join(', '));
    const navigateDirection = `javascript:${MapContextMenuEvents.UPDATE_TO_LOCATION}("${directionAddress}",
      ${markerDataObj.lat}, ${markerDataObj.lon})`;

    const directionLink = `<p><a class="direction-link" href='${navigateDirection}'>Directions</a></p>`;

    // Info window html content
    return `<div class='iw-traffic' id='aa-iwindow'>
              <div class="header">
                <h3><strong>${markerDataObj.operator || 'Car Park'}</strong></h3>
              </div>
              <hr>
              <div class="spacesCharge">
                  <span> ${markerDataObj.availableSpaces} Spaces </span><br>
                  <span>${markerDataObj.payment || ''}</span>
              </div>
              <hr>
              <div class="address" style="margin-bottom: 10px;">
                  ${$title}
                  <p>${markerDataObj.parkingAddress.addressLineOne}</p>
                  <p>${ addressToPopup.join(', ') }</p>
                  ${directionLink}
              </div>
              <div class="iw-wrapper">
                <div class="iw-content">
                    <a class="parkopedia" href='https://www.parkopedia.com/' target="_blank">
                      <img width="100%" src="./assets/images/parkopedia.png">
                    </a>
                </div>
                <div>
                  <a href="${markerDataObj.url}" target="_blank" class="btn primary detail-btn" role="button">Details</a>
                </div>
              </div>
            </div>
          </div>`;
  }

  /*
   * Info Window data parsing
   */
  getInfoWindowDateTime = taDate => {
    const taDatePartDD = taDate.split('T');
    taDatePartDD[0] = taDatePartDD[0].split('-');
    taDatePartDD[1] = taDatePartDD[1].substring(
      0,
      taDatePartDD[1].lastIndexOf(':')
    ); // remove seconds
    let hours = parseInt(
      taDatePartDD[1].substring(0, taDatePartDD[1].indexOf(':')),
      10
    );
    const app = hours >= 12 ? 'PM' : 'AM';
    if (hours > 12) {
      hours = hours - 12;
    } else if (hours === 0) {
      hours = 12;
    }
    const dateTime =
      taDatePartDD[0][2] +
      ' ' +
      [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec'
      ][taDatePartDD[0][1] - 1] +
      ' ' +
      taDatePartDD[0][0] +
      ', ' +
      hours +
      taDatePartDD[1].substring(2, taDatePartDD[1].length) +
      app;

    return dateTime;
  }


  reformatGoogleRouteResponse = results => {
    return {
      status: results.status,
      routes: this.reformatGoogleRoutes(results)
    };
  }

  reformatGoogleRoutes = routes => {
    const reformattedRoutes = [];
    for (let routeCounter = 0; routeCounter < routes.length; routeCounter++) {
      const obj = {
        summary: routes[routeCounter].summary,
        bounds: this.reformatGoogleBounds(routes[routeCounter].bounds),
        copyrights: routes[routeCounter].copyrights,
        overview_polyline: {
          points: routes[routeCounter].overview_polyline
        },
        legs: this.reformatGoogleLegs(routes[routeCounter].legs)
      };
      reformattedRoutes.push(obj);
    }
    return reformattedRoutes;
  }

  reformatGoogleLegs = legs => {
    const reformattedLegs = [];
    for (let legCounter = 0; legCounter < legs.length; legCounter++) {
      const newLeg = {
        distance: legs[legCounter].distance,
        duration: legs[legCounter].duration,
        duration_in_traffic: legs[legCounter].duration_in_traffic,
        end_address: legs[legCounter].end_address,
        end_location: this.reformatGoogleLatLng(legs[legCounter].end_location),
        start_address: legs[legCounter].start_address,
        start_location: this.reformatGoogleLatLng(
          legs[legCounter].start_location
        ),
        steps: this.reformatGoogleSteps(legs[legCounter].steps)
      };
      // legs[legCounter].duration_in_traffic && null != legs[legCounter].duration_in_traffic &&
      // (newLeg.duration_in_traffic = legs[legCounter].duration_in_traffic),
      reformattedLegs.push(newLeg);
    }
    return reformattedLegs;
  }

  reformatGoogleSteps = steps => {
    const reformattedSteps = [];
    for (let stepsCounter = 0; stepsCounter < steps.length; stepsCounter++) {
      const newStep = {
        distance: steps[stepsCounter].distance,
        duration: steps[stepsCounter].duration,
        duration_in_traffic: steps[stepsCounter].duration_in_traffic,
        end_location: this.reformatGoogleLatLng(
          steps[stepsCounter].end_location
        ),
        start_location: this.reformatGoogleLatLng(
          steps[stepsCounter].start_location
        ),
        html_instructions: steps[stepsCounter].instructions,
        maneuver: steps[stepsCounter].maneuver,
        polyline: steps[stepsCounter].polyline,
        travel_mode: steps[stepsCounter].travel_mode
      };
      reformattedSteps.push(newStep);
    }
    return reformattedSteps;
  }

  reformatGoogleBounds = bounds => {
    return {
      northeast: this.reformatGoogleLatLng(bounds.getNorthEast()),
      southwest: this.reformatGoogleLatLng(bounds.getSouthWest())
    };
  }

  reformatGoogleLatLng = latlng => {
    return {
      lat: latlng.lat().toFixed(6),
      lng: latlng.lng().toFixed(6)
    };
  }
  getRoadNumber(roadColor) {
    const value = roadColor.split('');
    if (value[0] && !isNaN(parseInt(value[1]))) {
      return value[0];
    } else {
      return null;
    }
  }
  getRoadType(roadName) {
    const roadNameInitial = this.getRoadNumber(roadName);
    let roadNameColor;
    switch (roadNameInitial) {
      case 'A':
      roadNameColor = 'a_roadType';
      break;
      case 'M':
      roadNameColor = 'm_roadType';
      break;
      default:
      roadNameColor = 'other_roadType';
      break;
    }
   return roadNameColor;
  }
}
